import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";

import Dashboard from "@dashboard/components/Dashboard";

import { useUserContext } from "@hooks/useUserContext";

const HomePage: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "home" });
  const { user } = useUserContext();

  return (
    <Page title={t("page_title", { userName: user.name })}>
      <Dashboard />
    </Page>
  );
};

export default HomePage;
